const ProjectMasterDataReducer = (state = {}, action) => {
    switch (action.type) {
        case "PROJECT_MASTER":
            return Object.assign({}, state, {
                Project_Master: action.data
            });
        default:
            return state;
    }
};

export default ProjectMasterDataReducer;
